/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_IntroInputs */

const en_us2_planshare_intro = /** @type {(inputs: Planshare_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a code for the plan you follow. Anyone with the app can see it and import it, reviewing it line by line. It carries the exercises, sets, reps and rests. Loads and notes stay with you.`)
};

const pt_br2_planshare_intro = /** @type {(inputs: Planshare_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere um código do seu plano em vigor. Quem tiver o app vê o plano e importa revisando linha a linha. Vão os exercícios, as séries, as repetições e os descansos. Cargas e anotações ficam só com você.`)
};

const pt_pt2_planshare_intro = /** @type {(inputs: Planshare_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere um código do seu plano em vigor. Quem tiver o app vê o plano e importa revisando linha a linha. Vão os exercícios, as séries, as repetições e os descansos. Cargas e anotações ficam só com você.`)
};

/** @type {(inputs: Planshare_IntroInputs) => LocalizedString} */
const es_419_planshare_intro = en_us2_planshare_intro;

/** @type {(inputs: Planshare_IntroInputs) => LocalizedString} */
const fr_fr2_planshare_intro = en_us2_planshare_intro;

/** @type {(inputs: Planshare_IntroInputs) => LocalizedString} */
const de_de2_planshare_intro = en_us2_planshare_intro;

/** @type {(inputs: Planshare_IntroInputs) => LocalizedString} */
const it_it2_planshare_intro = en_us2_planshare_intro;

/**
* | output |
* | --- |
* | "Create a code for the plan you follow. Anyone with the app can see it and import it, reviewing it line by line. It carries the exercises, sets, reps and rest..." |
*
* @param {Planshare_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_intro = /** @type {((inputs?: Planshare_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_intro(inputs)
	if (locale === "es-419") return es_419_planshare_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_intro(inputs)
	if (locale === "de-DE") return de_de2_planshare_intro(inputs)
	if (locale === "it-IT") return it_it2_planshare_intro(inputs)
	return en_us2_planshare_intro(inputs)
});
export { planshare_intro as "planshare.intro" }